// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import PostTileVerImageFeature from 'components/PostTile/PostTileVerImageFeature'
import PostTileHorImageSmall from 'components/PostTile/PostTileHorImageSmall'
import PostTileHorImageMedium from 'components/PostTile/PostTileHorImageMedium'
import PostTileVerImageMedium from 'components/PostTile/PostTileVerImageMedium'
import PostTileVerImageSmall from 'components/PostTile/PostTileVerImageSmall'
import PostTileVerTextSmall from 'components/PostTile/PostTileVerTextSmall'
import Image from 'components/Image/Image'

// Redux:
import { getPageData } from 'actions/page'

class CategoryLayout extends React.Component {
	constructor() {
		super()

		this.state = {
			numberOfPosts: 0,
			showSetA: false,
			showSetB: false,
			categoryPostsSetA: [],
			categoryPostsSetB: [],
			selectedDateYear: 'all',
			selectedDateMonth: 'all'
		}
	}

	componentDidMount() {
		const { dispatch, match } = this.props
		const { params } = match
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false

		this.update( match.params.slug, archivePageNumber )

		// Get posts:
		this.maybeUpdatePostSets()
	}

	componentDidUpdate( prevProps, prevState ) {
		// document.title = siteData.site_name

		if ( ! this.props.match ) {
			return
		}

		const { match, type, dispatch } = this.props
		const { params } = match
		const prevParams = prevProps.match.params

		// Get new data when the category changes:
		const archivePageNumber = params.archivePageNumber ? params.archivePageNumber : false
		const prevArchivePageNumber = prevParams.archivePageNumber ? prevParams.archivePageNumber : false

		if ( params.slug != prevParams.slug || archivePageNumber != prevArchivePageNumber ) {
			this.update( params.slug, archivePageNumber )

			// Get posts:
			this.maybeUpdatePostSets( prevState, true )
		} else {
			// Get posts:
			this.maybeUpdatePostSets( prevState )
		}
	}

	update = ( slug, archivePageNumber ) => {
		const { history, dispatch } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const isAppended = this.props.pageOverride ? true : false

		// Scroll to the top when not jumping to an anchor:
		if ( ! locationHash && ! isAppended ) {
			window.scrollTo( 0, 0 )
		}

		dispatch(
			getPageData( {
				type: 'posts',
				categorySlug: slug,
				number: 17,
				requestOnly: true
			} )
		)
	}

	maybeUpdatePostSets = ( prevState = false, forceUpdate = false ) => {
		const { match, postsById } = this.props
		const { numberOfPosts, selectedDateYear, selectedDateMonth } = this.state
		const slug = match.params.slug
		const catId = `id_${slug}`

		if ( ! postsById || ! postsById[ catId ] || ! postsById[ catId ].items ) {
			return
		}

		let doUpdate = false

		if ( forceUpdate ) {
			doUpdate = true
		}

		const newNumberOfPosts = Object.keys( postsById[ catId ].items ).length

		if ( numberOfPosts != newNumberOfPosts ) {
			doUpdate = true
		}

		if ( ! prevState || selectedDateYear != prevState.selectedDateYear || selectedDateMonth != prevState.selectedDateMonth ) {
			doUpdate = true
		}

		if ( ! doUpdate ) {
			return
		}

		const categoryPosts = postsById[ catId ].items

		let showSetA = false,
			showSetB = false

		if ( newNumberOfPosts == 5 ) {
			showSetA = true
		} else if ( newNumberOfPosts > 5 ) {
			showSetA = true
			showSetB = true
		} else {
			showSetB = true
		}

		let categoryPostsSetA = []
		let categoryPostsSetB = []
		let categoryPostsSetBStart

		if ( showSetA ) {
			categoryPostsSetA = Object.keys( categoryPosts ).slice( 0, 5 ).map( ( key ) => {
				return categoryPosts[ key ]
			})

			categoryPostsSetBStart = 5
		} else {
			categoryPostsSetBStart = 0
		}

		categoryPostsSetB = Object.keys( categoryPosts ).slice( categoryPostsSetBStart ).map( ( key ) => {
			let item = categoryPosts[ key ]

			if (
				( selectedDateYear != 'all' && item.date.year != selectedDateYear ) ||
				( selectedDateYear != 'all' && selectedDateMonth != 'all' && item.date.month != selectedDateMonth )
			) {
				return null
			}

			return item
		})

		categoryPostsSetB = categoryPostsSetB.filter( i => i )

		this.setState({
			numberOfPosts: newNumberOfPosts,
			showSetA: showSetA,
			showSetB: showSetB,
			categoryPostsSetA: categoryPostsSetA,
			categoryPostsSetB: categoryPostsSetB
		})
	}

	loadMorePosts = ( year = '', month = '', skip = '' ) => {
		const { dispatch, match, postsById } = this.props
		const { categoryPostsSetB, selectedDateYear, selectedDateMonth } = this.state
		const slug = match.params.slug
		const catId = `id_${slug}`
		let skipNumber = skip

		if ( ! skip ) {
			skipNumber = categoryPostsSetB.length
		}

		dispatch(
			getPageData( {
				type: 'more-posts',
				categorySlug: slug,
				year: selectedDateYear,
				month: selectedDateMonth,
				number: 20,
				skip: skipNumber,
				requestOnly: true,
				force: true
			} )
		)
	}

	handleDateYearChange = ( e ) => {
		const { selectedDateYear, selectedDateMonth, categoryPostsSetB } = this.state

		this.setState({
			selectedDateYear: e.target.value
		})

		// let numberOfPosts = categoryPostsSetB.length
		// this.loadMorePosts( e.target.value, selectedDateMonth, numberOfPosts )
		this.loadMorePosts()
	}

	handleDateMonthChange = ( e ) => {
		const { selectedDateYear, selectedDateMonth } = this.state

		this.setState({
			selectedDateMonth: e.target.value
		})

		this.loadMorePosts()
	}

	renderContent() {
		const { postsById, match, loadingById } = this.props
		const { selectedDateYear, selectedDateMonth, categoryPostsSetA, categoryPostsSetB, showSetA, showSetB } = this.state
		const slug = match.params.slug
		const catId = `id_${slug}`

		if ( ! postsById || ! postsById[ catId ] || ! postsById[ catId ].items ) {
			return null
		}

		const categoryData = postsById[ catId ]

		let featureMarkup = null,
			featureBMarkup = null,
			setA1Markup = null,
			setA2Markup = null,
			setA3Markup = null,
			setBMarkup = null,
			secondaryMarkup = null,
			popularMarkup = null

		featureMarkup = categoryPostsSetA && categoryPostsSetA.length ? categoryPostsSetA.slice( 0, 1 ).map( ( item ) => {
			return (
				<PostTileVerImageFeature
					key={ item.id }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					excerpt={ item.excerpt }
					author={ item.author }
					image={ item.featured_image }
					imageAlt={ item.title }
				/>
			)
		}) : false

		setA1Markup = categoryPostsSetA && categoryPostsSetA.length ? categoryPostsSetA.slice( 1, 4 ).map( ( item ) => {
			return (
				<PostTileHorImageMedium
					key={ item.id }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
				/>
			)
		}) : false

		featureBMarkup = categoryPostsSetA && categoryPostsSetA.length ? categoryPostsSetA.slice( 4, 5 ).map( ( item ) => {
			return (
				<PostTileHorImageMedium
					key={ item.id }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					excerpt={ item.excerpt }
					author={ item.author }
					image={ item.featured_image }
					imageAlt={ item.title }
				/>
			)
		}) : false

		secondaryMarkup = categoryPostsSetB && categoryPostsSetB.length ? categoryPostsSetB.slice( 0, 3 ).map( ( item ) => {
			return (
				<PostTileVerImageFeature
					key={ item.id }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					excerpt={ item.excerpt }
					image={ item.featured_image }
					imageAlt={ item.title }
				/>
			)
		}) : false

		popularMarkup = categoryData.popular && Object.keys( categoryData.popular ).length ? Object.keys( categoryData.popular ).slice( 0, 5 ).map( ( key, i ) => {
			let item = categoryData.popular[ key ]

			return (
				<PostTileHorImageMedium
					key={ key }
					url={ item.url }
					title={ item.title }
					category={ item.category.primary.name }
					author={ item.author }
					image={ item.featured_image }
					imageAlt={ item.title }
					number={ i + 1 }
				/>
			)
		}) : false

		let i = 0
		let setBNumber = categoryPostsSetB.length
		setBMarkup = categoryPostsSetB.map( ( item ) => {
			i++

			if ( i == ( setBNumber - 3 ) ) {
				// With waypoint to trigger the fetch of more posts:
				return (
					<PostTileHorImageMedium
						key={ item.id }
						url={ item.url }
						title={ item.title }
						category={ item.category.primary.name }
						author={ item.author }
						excerpt={ item.excerpt }
						image={ item.featured_image }
						imageAlt={ item.title }
						handleWaypointEnter={ this.loadMorePosts }
					/>
				)
			} else {
				return (
					<PostTileHorImageMedium
						key={ item.id }
						url={ item.url }
						title={ item.title }
						category={ item.category.primary.name }
						author={ item.author }
						excerpt={ item.excerpt }
						image={ item.featured_image }
						imageAlt={ item.title }
					/>
				)
			}
		})

		// if ( categoryData.popular ) {
		// 	popularMarkup = Object.keys( categoryData.popular ).slice( 0, 5 ).map( ( key ) => {
		// 		let item = categoryData.popular[ key ]

		// 		return (
		// 			<PostTileVerTextSmall
		// 				key={ key }
		// 				url={ item.url }
		// 				title={ item.title }
		// 				author={ item.author }
		// 				date={ item.date.display }
		// 			/>
		// 		)
		// 	})
		// }

		// Date selection:
		let yearsMarkup,
			yearsOptionsMarkup,
			monthsMarkup,
			monthsOptionsMarkup

		if ( categoryData.dates ) {
			yearsOptionsMarkup = Object.keys( categoryData.dates ).map( ( key ) => {
				let item = categoryData.dates[ key ]

				return (
					<option key={ key } value={ item.n }>{ item.display }</option>
				)
			})
		}

		if ( yearsOptionsMarkup ) {
			yearsMarkup = (
				<div className="form-item form-select">
					<i className="icon-chevron-down" aria-hidden="true"></i>

					<select onChange={ this.handleDateYearChange } value={ selectedDateYear }>
						<option key="all" value="all">All years</option>

						{ yearsOptionsMarkup }
					</select>
				</div>
			)
		}

		if ( categoryData.dates && categoryData.dates[ `id_${selectedDateYear}` ] ) {
			monthsOptionsMarkup = Object.keys( categoryData.dates[ `id_${selectedDateYear}` ].months ).map( ( key ) => {
				let item = categoryData.dates[ `id_${selectedDateYear}` ].months[ key ]

				return (
					<option key={ key } value={ item.n }>{ item.display }</option>
				)
			})
		}

		// Show if there are years:
		if ( yearsOptionsMarkup ) {
			monthsMarkup = (
				<div className="form-item form-select">
					<i className="icon-chevron-down" aria-hidden="true"></i>

					<select onChange={ this.handleDateMonthChange } value={ selectedDateMonth }>
						<option key="all" value="all">All months</option>

						{ monthsOptionsMarkup }
					</select>
				</div>
			)
		}

		return (
			<div className="wide-sections">
				{ featureMarkup &&
					<section className="posts-section-feature">
						<div className="-inner">
							{ featureMarkup }
						</div>
					</section>
				}

				<section className="posts-section-a">
					{/*<div className="-heading">
						<h2>The Latest</h2>
					</div>*/}

					<div className="-inner">
						<section className="with-vertical">
							{ setA1Markup }
						</section>
					</div>
				</section>

				{ featureBMarkup &&
					<section className="posts-section-feature-b">
						<div className="-inner">
							{ featureBMarkup }
						</div>
					</section>
				}

				<section className="posts-section-b">
					<div className="-primary">
						{ secondaryMarkup &&
							<section className="-posts">
								<div className="-inner">
									<section className="with-vertical">
										{ secondaryMarkup }
									</section>
								</div>
							</section>
						}
					</div>

					{ popularMarkup &&
						<div className="-secondary">
							<div className="-heading">
								<div className="-e">
									<img className="site-logo" src={ `${siteData.images_url}logo/e-dark.svg` } alt="" />
								</div>

								<h2>Popular</h2>
							</div>

							<div className="-inner">
								<section>
									{ popularMarkup }
								</section>
							</div>
						</div>
					}
				</section>
			</div>
		)
	}

	render() {
		const { postsById, loadingById, match } = this.props
		const slug = match.params.slug
		const catId = `id_${slug}`
		const markup = this.renderContent()

		return (
			<div>
				<div className="main-inner">
					{ loadingById && loadingById[ catId ] &&
						<LoadingSpinner />
					}

					{ markup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		postsById: state.page.postsById,
		loadingById: state.page.loadingById
	}
}

export default connect( mapStateToProps )( CategoryLayout )
